import type { ReactNode } from "react";

/** Keep matches readable without adding a second competing pill inside active tabs. */
const MATCH_CLASS =
  "font-semibold text-[var(--color-black-9)]";

/**
 * Wraps the first case-insensitive occurrence of `query` in `label`.
 * If no match, returns `label` as text.
 */
export function tabLabelWithSearchHighlight(
  label: string,
  query: string
): ReactNode {
  const q = query.trim();
  if (!q) return label;
  const lower = label.toLowerCase();
  const qi = lower.indexOf(q.toLowerCase());
  if (qi === -1) return label;
  const before = label.slice(0, qi);
  const mid = label.slice(qi, qi + q.length);
  const after = label.slice(qi + q.length);
  return (
    <>
      {before}
      <span className={MATCH_CLASS}>{mid}</span>
      {after}
    </>
  );
}
